(() => {
  const roots = () => Array.from(document.querySelectorAll('.camel-collection-page'));
  const isOpen = root => root.querySelector('filter-container')?.classList.contains('filter-container--show-filters-mobile');
  const sync = (root, trigger) => {
    const panel = root.querySelector('.filters');
    if (!panel) return;
    const open = isOpen(root);
    panel.inert = !open;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', root.querySelector('.filters__heading-text')?.textContent.trim() || '');
    root.querySelectorAll('.toggle-btn[data-toggle-filters]').forEach(button => button.setAttribute('aria-expanded', String(open)));
    if (open && trigger && !panel.contains(trigger)) {
      root.camelFilterTrigger = trigger;
      panel.querySelector('.filters__close')?.focus();
    } else if (!open && root.camelFilterTrigger) {
      root.camelFilterTrigger.focus();
      root.camelFilterTrigger = null;
    }
  };
  const init = () => roots().forEach(root => sync(root));
  document.addEventListener('click', event => {
    const target = event.target;
    document.querySelectorAll('.camel-quick-filter[open]').forEach(detail => {
      if (!detail.contains(target)) detail.open = false;
    });
    const toggle = target.closest('.camel-collection-page [data-toggle-filters]');
    if (toggle) requestAnimationFrame(() => sync(toggle.closest('.camel-collection-page'), toggle));
  });
  document.addEventListener('keydown', event => {
    const root = roots().find(isOpen);
    if (root) {
      const panel = root.querySelector('.filters');
      if (event.key === 'Escape') {
        event.preventDefault();
        panel.querySelector('.filters__close')?.click();
      } else if (event.key === 'Tab') {
        const focusable = Array.from(panel.querySelectorAll('a[href], button, input, select, [tabindex="0"]')).filter(element => !element.disabled && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    } else if (event.key === 'Escape') {
      document.querySelectorAll('.camel-quick-filter[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); });
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('.camel-price-form')) return;
    const inputs = event.target.querySelectorAll('input[type=number]');
    if (inputs[0].value && inputs[1].value && Number(inputs[0].value) > Number(inputs[1].value)) {
      event.preventDefault();
      inputs[1].value = inputs[0].value;
      inputs[1].focus();
    }
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
